import {triggerDocumentEvent} from "@js/globalFunctions/events";
import {buildDateFromString} from "@js/globalFunctions/dateHandling";
import getDateWeekNr from "@js/globalFunctions/getDateWeekNr";

export function updateSearchCountDisplay(newNumber, currentNumber, animate)
{
    const arrival = searchParameters.getParameter('ankomst');
    const hasArrival = typeof arrival !== 'undefined' && arrival !== '';
    const animateTo = hasArrival && newNumber > 250 ? 250 : newNumber;

    $('.searchDisplayName').each(function(i, el) {
        const searchDisplayName = (siteID === '1') ? 'sommerhuse' : 'Häuser';
        $(el).html(searchDisplayName);
    });

    let displayIndeterminate = false;
    if(hasArrival && newNumber < 11)
    {
        const weekNr = getDateWeekNr(buildDateFromString(arrival))
        if([29,30,31,32,33,34].indexOf(weekNr) !== -1)
            displayIndeterminate = true;
    }

    $('.fullSearchSubmitClass').each(function(i, el) {
        $(el).removeClass('hidden');
        if(typeof animate === 'undefined' || animate === true)
            $(el).prop('number', currentNumber).animateNumber({number: animateTo},500);

        $(el).attr('data-real-number',newNumber)
        $(el).html(animateTo);
        const text =  $(el).closest('.search-result-text');
        if(hasArrival && newNumber > 250)
        {
            text.find('.search-plus').removeClass('hidden');
        }
        else
        {
            text.find('.search-plus').addClass('hidden');
        }

        if(hasArrival)
        {
            text.find('.searchDisplayNameFree').removeClass('hidden');
            text.find('.searchDisplayName').addClass('hidden');
        }
        else
        {
            text.find('.searchDisplayNameFree').addClass('hidden');
            text.find('.searchDisplayName').removeClass('hidden');

        }

        if(displayIndeterminate)
        {
            text.find('.search-result-text-regular').addClass('hidden');
            text.find('.search-result-text-indeterminate').removeClass('hidden');
        }
        else
        {
            text.find('.search-result-text-regular').removeClass('hidden');
            text.find('.search-result-text-indeterminate').addClass('hidden');
        }

    });
    triggerDocumentEvent('searchCountChanged',newNumber)
}
